<template>
    <modal size="lg" :height-max="false" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editCompanyModal">
        <template v-slot:title>
            <h3 class="modal-title">Edit Company</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                </div>
            </div>

            <form-errors :errors="formErrors"/>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <form>
                                <form-input label="EIN" v-model="formData.EIN" :errors="errors.EIN" type="text" :maxlength="100"/>
                                <form-input label="Legal Name" v-model="formData.name" :errors="errors.name" type="text" :maxlength="100"/>
                                <form-input label="Friendly Name" v-model="formData.known_as" :errors="errors.known_as" type="text" :maxlength="100"/>
                                <form-input label="Doing Business As" v-model="formData.dba" :errors="errors.dba" type="text" :maxlength="100"/>
                                <form-input label="Address 1" v-model="formData.address_1" :errors="errors.address_1" type="text" :maxlength="100"/>
                                <form-input label="Address 2 (Optional)" v-model="formData.address_2" :errors="errors.address_2" type="text" :maxlength="100"/>
                                <form-input label="City" v-model="formData.city" :errors="errors.city" type="text" :maxlength="100"/>

                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="State" v-model="formData.state" :errors="errors.state" type="select" :options="stateOptions"/>
                                    </div>

                                    <div class="col-6">
                                        <form-input label="Zip Code" :maxlength="5" v-model="formData.postal_code" :errors="errors.postal_code" type="text" inputmode="tel" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="card mt-2">
                        <div class="card-body">
                            <h5>POS Integration</h5>
                            <form>
                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="Franchisee Code" v-model="formData.franchisee_code" :errors="errors.franchisee_code" type="text" :maxlength="30" helper-text="Necessary for TCP+ integration."/>
                                    </div>
                                    <div class="col-6" v-if="client.clocking_id_enabled">
                                        <form-input label="Show Clocking ID" type="checkbox" v-model="formData.show_clocking_id" :errors="errors.show_clocking_id" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="TC+ Store Code Width" v-model="formData.tcpplus_store_code_width" :errors="errors.tcpplus_store_code_width" type="select" :options="storeCodeWidthOptions" noblank helper-text="Store digits in TC+ job codes (franchise + store + role). Most stores use 2."/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import STATES from '@/states'

export default {
    props: ['client', 'company'],
    mixins: [FormMixin, ModalMixin],
    components: {},
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    watch: {
        company() {
            this.reset()
        }
    },
    mounted() {},
    computed: {
        stateOptions() {
            const opts = []
            STATES.forEach(s => {
                opts.push({text: s.name.toUpperCase(), value: s.abbreviation})
            })
            return opts
        },
        storeCodeWidthOptions() {
            return [2, 3, 4, 5].map(w => ({text: `${w} digits (store 18 → ${'18'.padStart(w, '0')})`, value: String(w)}))
        },
    },
    methods: {
        makeFormData() {
            let company = JSON.parse(JSON.stringify(this.company))
            const data = {
                EIN: company.EIN,
                name: company.name,
                known_as: company.known_as,
                dba: company.dba,
                address_1: company.address_1,
                address_2: company.address_2,
                city: company.city,
                state: company.state,
                postal_code: company.postal_code,
                show_clocking_id: company.show_clocking_id,
                franchisee_code: company.franchisee_code,
                tcpplus_store_code_width: String(company.tcpplus_store_code_width ?? 2),
            }
            return data
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.patch(`/clients/${this.client.id}/settings/companies/${this.company.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
